import React from "react";
import { Link, useLocation } from "react-router-dom";

const PurchaseOrderTabBar = ({ poId }) => {
  const location = useLocation();

  const tabs = [
    {
      id: "general",
      label: "General",
      link: `/purchaseOrder/updatePurchaseOrder/${poId}`,
      icon: "fa fa-info-circle"
    },
    {
      id: "items",
      label: "Items",
      link: `/purchaseOrder/updatePurchaseOrderItems/${poId}`,
      icon: "fa fa-box"
    },
    {
      id: "payments",
      label: "Payments",
      link: `/purchaseOrder/updatePurchaseOrderPayments/${poId}`,
      icon: "fa fa-credit-card"
    },
  ];

  const getActiveTab = () => {
    if (location.pathname.includes("updatePurchaseOrderPayments")) {
      return "payments";
    }
    if (location.pathname.includes("updatePurchaseOrderItems")) {
      return "items";
    }
    return "general";
  };

  const activeTab = getActiveTab();

  return (
    <ul className="nav nav-tabs nav-tabs-v2 px-3 mb-3">
      {tabs.map((tab) => (
        <li className="nav-item me-2" key={tab.id}>
          <Link
            to={tab.link}
            className={`nav-link px-2 ${activeTab === tab.id ? "active" : ""}`}
          >
            <i className={`${tab.icon} me-2`}></i>
            {tab.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default PurchaseOrderTabBar;